module.exports = __webpack_public_path__ + "media/images/about_channels_hero-f6411856399d6be3920295de06862599.jpeg";